export function convertVisibleFieldFormToRequest(data) {
  const ret = {
    colId: data.colId,
  };
  if (data.aggregationType) {
    ret.aggregationType = data.aggregationType;
  }
  return ret;
}
